import React from "react";
import { X, FileText, Plus } from "lucide-react";
import type { OpenDocument } from "../state/documentStore";

interface TabBarProps {
  tabs: OpenDocument[];
  activeId: string | null;
  onSelect: (id: string) => void;
  onClose: (id: string) => void;
  onOpen: () => void;
}

/** Tab strip for multiple open PDFs — only rendered once more than one is open. */
const TabBar: React.FC<TabBarProps> = ({ tabs, activeId, onSelect, onClose, onOpen }) => {
  if (tabs.length < 2) return null;
  return (
    <div className="tab-bar" role="tablist">
      {tabs.map((t) => (
        <div
          key={t.id}
          role="tab"
          aria-selected={t.id === activeId}
          className={`tab-item ${t.id === activeId ? "tab-item-active" : ""}`}
          onClick={() => onSelect(t.id)}
          title={t.fileName}
        >
          <FileText size={13} />
          <span className="tab-item-name">
            {t.fileName}
            {t.dirty ? "*" : ""}
          </span>
          <button
            className="tab-item-close"
            title="Close tab"
            onClick={(e) => {
              e.stopPropagation();
              onClose(t.id);
            }}
          >
            <X size={12} />
          </button>
        </div>
      ))}
      <button className="tab-item-add" title="Open another PDF" onClick={onOpen}>
        <Plus size={14} />
      </button>
    </div>
  );
};

export default TabBar;
